import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export interface AuditLog {
  id: string;
  action: string;
  entityType?: string | null;
  entityName?: string | null;
  endpoint?: string | null;
  method?: string | null;
  statusCode?: number | null;
  tags?: string[];
  metadata?: Record<string, unknown> | null;
  timestamp?: string;
  tenantId?: string | null;
  userId?: string | null;
  user?: { email?: string } | null;
  tenant?: { name?: string } | null;
}

export interface AuditPage {
  logs: AuditLog[];
  pagination: { page: number; limit: number; total: number; totalPages: number };
}

export const getAuditLogs = (params?: {
  page?: number;
  limit?: number;
  action?: string;
  actions?: string; // CSV — filter to a curated set (e.g. the access-changes feed)
  search?: string;
  tenantId?: string;
}) => axios.get<AuditPage>(`${API_V1}/audit-logs`, { params }).then((r) => r.data);

// Curated access/governance actions for the platform security "Access changes"
// view. Order = display order in the filter. Labels are human-friendly.
export const ACCESS_ACTIONS: { value: string; label: string }[] = [
  { value: 'user.role.assign', label: 'Role assigned' },
  { value: 'operator.invite', label: 'Operator invited' },
  { value: 'operator.activate', label: 'Operator activated' },
  { value: 'operator.deactivate', label: 'Operator deactivated' },
  { value: 'tenant.suspend', label: 'Tenant suspended' },
  { value: 'tenant.terminate', label: 'Tenant terminated' },
  { value: 'tenant.reactivate', label: 'Tenant reactivated' },
  { value: 'session.revoke', label: 'Session revoked' },
  { value: 'impersonate', label: 'Impersonation' },
  { value: 'high_risk_access_attempt', label: 'High-risk access' },
];
export const ACCESS_ACTIONS_CSV = ACCESS_ACTIONS.map((a) => a.value).join(',');
